/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RequestStatus = {
    Draft: 'draft',
    Open: 'open',
    Completed: 'completed',
    Withdrawn: 'withdrawn',
} as const;
export type RequestStatus = typeof RequestStatus[keyof typeof RequestStatus];


export function instanceOfRequestStatus(value: any): boolean {
    for (const key in RequestStatus) {
        if (Object.prototype.hasOwnProperty.call(RequestStatus, key)) {
            if (RequestStatus[key as keyof typeof RequestStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RequestStatusFromJSON(json: any): RequestStatus {
    return RequestStatusFromJSONTyped(json, false);
}

export function RequestStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestStatus {
    return json as RequestStatus;
}

export function RequestStatusToJSON(value?: RequestStatus | null): any {
    return value as any;
}

export function RequestStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): RequestStatus {
    return value as RequestStatus;
}

